import { Button, Paragraph } from '@deckee/deck-hand';

import React, { FC, useEffect, useRef } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import { useAppDispatch } from '../../../../services/store';
import {
  addTemporaryLocationMarker,
  clearTemporaryLocationMarkers,
} from '../../../../services/store/modules/temporaryMarkers';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
import useMoveMapToLocation from '../../Marketplace/hooks/use-move-map-to-location';

const DropTemporaryPinPage: FC = () => {
  const { search } = useLocation();
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>(null);

  const client = ref?.current || { clientHeight: 0, clientWidth: 0 };
  const sheetHeight = client.clientHeight;
  const sheetWidth = client.clientWidth;

  // Hard coded pixel size of when the app switches to mobile size
  const isMobile = (window.innerWidth || 0) <= 800;
  const params = new URLSearchParams(search);
  const longitude = params.get('longitude');
  const latitude = params.get('latitude');

  useMoveMapToLocation({
    center: {
      lat: parseFloat(latitude || '90'),
      lon: parseFloat(longitude || '90'),
    },
    offsetY: isMobile ? sheetHeight * 0.45 : 0,
    offsetX: !isMobile ? -sheetWidth * 0.45 : 0,
  });

  const handleClick = () => {
    captureEvent({
      type: 'drop-pin: click install app from temporary drop pin',
      payload: {},
      sendToAmplitude: true,
    });
  };

  useEffect(() => {
    dispatch(
      addTemporaryLocationMarker({
        latitude: parseFloat(latitude || '90'),
        longitude: parseFloat(longitude || '90'),
      }),
    );

    return () => {
      dispatch(clearTemporaryLocationMarkers());
    };
  }, [dispatch, latitude, longitude]);

  // CAUTION: we're pulling these values from the search params so if either the lon or lat is "0", it will still
  // be ok, as it's a string. If this was to ever change, the following logic would not work
  if (!longitude || !latitude) {
    return <Redirect to="/maps" />;
  }

  return (
    <SheetLayout heading="Want more details?">
      <SheetBody>
        <Paragraph pb="2">
          Get the free Deckee app for the best experience.
        </Paragraph>

        <Button wide href="https://deckee.com/download" onClick={handleClick}>
          Install app
        </Button>
      </SheetBody>
    </SheetLayout>
  );
};

export default DropTemporaryPinPage;
